

import { Login } from '../models/login'
import { computed} from 'vue'
import { ref } from 'vue'
import AuthRepository from '../services/AuthRepository'
import { useStore } from 'vuex'
import { useToast } from 'primevue/usetoast'
import { useRouter } from 'vue-router'
import CDCRepository from "@/services/CDCRepository";

export default {

  setup (props) {
    const router = useRouter();
    const login = ref({} as Login);
    const store = useStore();
    const toast = useToast();
    const userName = ref("");
    const password = ref("");

    const valid = computed(() => password.value && userName.value)

    const doLogin = () => {
        var md5 = require("md5");
        login.value.username = userName.value;
        login.value.password = md5(password.value);
      AuthRepository.auth(login.value)
        .then((response) => {
          store.dispatch('setToken', response.data.token);
          CDCRepository.getUserInfo().then((response) => {
            store.dispatch('setFullName', response.data.fullName);
            store.dispatch('setTeam', response.data.team);
            store.dispatch('setReport', response.data.report);
          })
          toast.add({
            severity: 'success',
            summary: 'Đăng nhập',
            detail: 'Đăng nhập thành công vào hệ thống',
            life: 1000
          });
          AuthRepository.userPermission(login.value)
                  .then((responses)=>{
                    store.dispatch('setPermission', responses.data.permission);
                    router.push({
                      name: ''
                    });
                  })
                  .catch(() => {
                  });
        })
        .catch(err => {
          toast.add({
            severity: 'error',
            summary: 'Đăng nhập',
            detail: err.response.data,
            life: 4000
          })
        })

    }

    return {
      login,
      doLogin,
      valid,
      password,
      userName,
    }
  }
}

